import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { Badge } from '@/shared-ui/atoms';
import type { AppliedFilter } from '../../../lib/refinements';
import { ClearAllButton } from '../clear-all-button';

export interface AppliedFiltersProps {
    filters: AppliedFilter[];
    onRemove: (attributeId: string, value: string) => void;
    onClearAll: () => void;
    /** `wrap` for the desktop panel, `scroll` for the mobile horizontal carousel. */
    layout?: 'wrap' | 'scroll';
    className?: string;
}

export const AppliedFilters = ({ filters, onRemove, onClearAll, layout = 'wrap', className }: AppliedFiltersProps) => {
    const { t } = useTranslation('plpFilters');

    if (filters.length === 0) return null;

    return (
        <div
            data-slot="applied-filters"
            aria-label={t('appliedFilters')}
            role="group"
            className={cn(
                'flex items-center gap-2',
                layout === 'wrap' ? 'flex-wrap' : 'overflow-x-auto [scrollbar-width:none]',
                className
            )}>
            {filters.map(({ attributeId, value, label }) => (
                <Badge
                    key={`${attributeId}:${value}`}
                    shape="pill"
                    className="shrink-0"
                    dismissLabel={t('removeFilter', { label })}
                    onDismiss={() => onRemove(attributeId, value)}>
                    {label}
                </Badge>
            ))}
            <ClearAllButton onClick={onClearAll} className="shrink-0" />
        </div>
    );
};
